import React, { useState } from 'react';
import NavTab from './nav_tab';

const CommunityManageNav = ({ name }) => {
  const navBarTabs = [
    // "dashboard",
    'members',
    // "billing",
    // "sponsors",
    'settings'
    // "activity",
  ];
  const initSelection = location.pathname.split('/').reverse()[0];
  const [selectedTab, setSelectedTab] = useState(initSelection);

  const createTabs = () => {
    return navBarTabs.map((tab, idx) => (
      <NavTab
        key={tab + String(idx)}
        tab={tab}
        onClick={() => setSelectedTab(tab)}
        selected={tab === selectedTab}
        isNavBar={true}
      />
    ));
  };

  const navStyles = () => ({
    width: '100%',
    position: 'fixed',
    background: '#FFF',
    zIndex: 10,
    top: 0,
    maxWidth: 'inherit'
  });

  return (
    <>
      <section className="pt-9" style={navStyles()}>
        <div className="container-xxl">
          <header>
            <p className="h2 mb-0 mb-md-4 border-bottom">{name}</p>
          </header>
          <nav className="border-bottom">
            <p className="h4">Manage Community</p>
            <ul className="nav flex-nowrap" style={{ overflowY: 'auto' }}>{createTabs()}</ul>
          </nav>
        </div>
      </section>
      <div className="header-placeholder"></div>
    </>
  );
};

export default CommunityManageNav;
